import React, { ReactNode } from 'react';
import './Button.less';
import classNames from 'classnames';
import Spinner from '../../common/Spinner/Spinner';
import { EnvagoAria } from '../../../aria.types';

export interface ButtonProps {
    children: ReactNode;
    primary?: boolean;
    secondary?: boolean;
    accent?: boolean;
    onClick?: () => void;
    block?: boolean;
    className?: string;
    disabled?: boolean;
    small?: boolean;
    ghost?: boolean;
    iconButton?: boolean;
    isLoading?: boolean;
    aria?: EnvagoAria;
    onDragEnter?: React.DragEventHandler<HTMLButtonElement>;
    onDragOver?: React.DragEventHandler<HTMLButtonElement>;
    onDragLeave?: React.DragEventHandler<HTMLButtonElement>;
    onDrop?: React.DragEventHandler<HTMLButtonElement>;
}

const Button = ({
    children,
    primary,
    secondary,
    accent,
    ghost,
    onClick,
    block = false,
    className,
    disabled = false,
    small = false,
    iconButton = false,
    isLoading = false,
    aria,
    onDragEnter,
    onDragOver,
    onDragLeave,
    onDrop,
}: ButtonProps) => {
    return (
        <button
            onClick={() => {
                if (isLoading) return;

                onClick && onClick();
            }}
            {...aria}
            onKeyDown={(event) => {
                if (event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }
                if (disabled || isLoading) return;
                onClick && onClick();
            }}
            disabled={disabled}
            onDragEnter={onDragEnter}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
            className={classNames('button flex justify-center', className, {
                'button--primary': !disabled && primary,
                'button--secondary': !disabled && secondary,
                'button--accent': !disabled && accent,
                block: block,
                'w-full': block,
                'button--disabled': disabled,
                'button--small': small && !iconButton,
                'button--ghost': !disabled && ghost,
                'button--icon': iconButton,
            })}
        >
            <div className={'button-text-wrapper flex items-center'}>
                {isLoading && (
                    <div className={'mr-2'}>
                        <Spinner size={18} color={'#999'} />
                    </div>
                )}
                {children}
            </div>
        </button>
    );
};

export default Button;
